export enum RefundType {
  返金 = 1,
  預り金 = 2,
}
